// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"f12d9d8c","513":"41a0336e"}[chunkId] + ".chunk.js";
};